import { PRESUPUESTADOR_SET_PAY } from './constants'

export function setPay(state) {
    return dispatch => {
        dispatch({
            type: PRESUPUESTADOR_SET_PAY,
            data: { pay: state }
        })
    }
}

export function reducer(state, action) {
    if (action.type === PRESUPUESTADOR_SET_PAY) {
        return {
            ...state,
            pay: action.data.pay,
        }
    } else {
        return state
    }
}